import React from "react"
import { cn } from "lib/utils"
import { useRenderStyling } from 'lib/hooks/useRenderStyling';
import { TrxDetailBlock, TrxDetailHeader, TrxDetailDataElement } from "."



export default function DetailScreenCustomerInfo({
  screen,
  renderPkg
}:{
  screen:any; 
  renderPkg?:any
}){

  const userDataWrapper = useRenderStyling("w-6/12 flex flex-col pt-0 pb-0", "styleObj")
  const userDataStyle = useRenderStyling("w-full pl-3 pr-3 flex flex-col pt-1 pb-1", "styleObj")

  return (
    <div className={cn("w-full flex items-stretch")}>
      <div {...userDataWrapper}>
        <TrxDetailBlock mergeSide="left">
          <TrxDetailHeader title="Billing Information" />
          <div {...userDataStyle}>
            <TrxDetailDataElement label="" value={screen.billing.name} />
            <TrxDetailDataElement label="" value={screen.billing.address} />
            <TrxDetailDataElement label="" value={screen.billing.city} />
            <TrxDetailDataElement label="" value={screen.billing.state} />
            <TrxDetailDataElement label="" value={screen.billing.zip} />
            <TrxDetailDataElement label="" value={screen.billing.country} />
            <TrxDetailDataElement label="" value={screen.billing.phone} />
          </div>
        </TrxDetailBlock>
      </div>
      
      <div {...userDataWrapper}>
        <TrxDetailBlock mergeSide="right">
          <TrxDetailHeader title="Shipping Information" />
          <div {...userDataStyle}>
            <TrxDetailDataElement label="" value={screen.shipping.name} />
            <TrxDetailDataElement label="" value={screen.shipping.address} />
            <TrxDetailDataElement label="" value={screen.shipping.city} />
            <TrxDetailDataElement label="" value={screen.shipping.state} />
            <TrxDetailDataElement label="" value={screen.shipping.zip} />
            <TrxDetailDataElement label="" value={screen.shipping.country} />
            <TrxDetailDataElement label="" value={screen.shipping.phone} />
          </div>
        </TrxDetailBlock>
      </div>
    </div>
  )
}